export function typewriter (el) {
  let speed = parseFloat(el.dataset.typeSpeed);
  if(!speed) speed = 100
  let string = el.dataset.string.split("");
  if(string.length) {
    string.forEach((char, index) => {
      setTimeout(() => {
        el.textContent += char;
      }, speed * index);
    });
  }
};